import { useEffect, useState } from "react";
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  LinkedinShareButton,
  FacebookIcon,
  LinkedinIcon,
  WhatsappIcon,
  TwitterIcon,
} from "react-share";

import Banner from "../banner/banner";
import Page from "../page/page";
import ReactGA from "react-ga4";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

import "./OrderSuccessPage.scss";
import classNames from "classnames";
import {
  addDoc,
  collection,
  doc,
  getDoc,
  getDocs,
  setDoc,
} from "firebase/firestore";
import { shotamDatabase } from "../../firebase";
import { generateCode, sendCodeInDatabase } from "../services/api";
import { RANDOM_CODE_CHARS, RANDOM_CODE_LENGTH } from "../../constants";

export const checkAllowedToBuyNewTokens = async (code) => {
  const codeSnap = await getDoc(doc(shotamDatabase, "players", code));
  if (codeSnap.exists()) {
    const { nbTokens } = codeSnap.data();
    return nbTokens <= 0;
  } else {
    return true;
  }
};

const OrderSuccessPage = () => {
  const navigate = useNavigate();
  const [code, setCode] = useState("");
  const [searchParams] = useSearchParams();
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const session_id = searchParams.get("session_id");
    const existingCode = window.localStorage.getItem("shotamCode");
    if (
      document.referrer === "https://buy.stripe.com/" &&
      session_id &&
      !existingCode
    ) {
      const pseudo = window.localStorage.getItem("shotamPseudo");
      let newCode = generateCode(pseudo ?? "");
      setCode(newCode);
      window.localStorage.setItem("shotamCode", newCode);
    }
    if (existingCode) {
      setCode(existingCode);
    }
  }, []);

  const handleBuyAgain = async () => {
    const allowed = true; //  await checkAllowedToBuyNewTokens(code);
    if (allowed) {
      setErrorMessage("");
      window.localStorage.removeItem("shotamCode");
      navigate("/user");
    } else {
      setErrorMessage("Tu as déjà un jeton !");
    }
  };

  return (
    <>
      <Page>
        <div className="buyingStep">
          <div className="fightText">Fight !</div>
          <div className="stepTitle">Enfile le casque, et entre ton code :</div>
          {code ? <div className="code">{code}</div> : <></>}
        </div>
        <div className="actionButtonsContainer">
          <button className="actionButton" onClick={handleBuyAgain}>
            Racheter un jeton
          </button>
        </div>
        {errorMessage ? <div className="hint">{errorMessage}</div> : <></>}
      </Page>
    </>
  );
};

export default OrderSuccessPage;
